import { AGENT_DETAIL_URL_SOURCE } from "./userOffer";

type BuildUrlOptions = {
  baseSrc?: string;
};

const BASE_ALLOWED_HOSTS = ["propally.co.jp", "www.propally.co.jp", "propally.jp", "www.propally.jp"];

export const isAllowedHost = (hostname: string): boolean => {
  if (BASE_ALLOWED_HOSTS.includes(hostname)) {
    return true;
  }
  if (typeof window !== "undefined" && hostname === window.location.host) {
    return true;
  }
  return false;
};

export const isAllowedUrl = (url: string | undefined): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && isAllowedHost(parsed.hostname);
  } catch {
    return false;
  }
};

export const buildUrlFromPath = (path: string, { baseSrc }: BuildUrlOptions): URL => {
  const origin = baseSrc ? new URL(baseSrc).origin : window.location.origin;
  return new URL(path, origin);
};

export const navigateWithinApp = (
  history: { push: (path: string) => void },
  url: URL,
  options: { appendLearningSource?: boolean } = {}
) => {
  const nextUrl = new URL(url.toString());
  if (options.appendLearningSource && nextUrl.pathname.startsWith("/agent_search")) {
    nextUrl.searchParams.set("source", AGENT_DETAIL_URL_SOURCE.LEARNING_ARTICLE);
  }
  const path = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
  history.push(path);
};
